/* tab标签导航栏 */
export function removeTab (tabName, that) {
  let TabList = JSON.parse(JSON.stringify(that.TabList))
  that.TabList = that.TabList.filter(item => item.name !== tabName)
  // 如果关闭的是当前选择的标签
  if (tabName === that.activeTab) {
    let i = TabList.length
    // 找出所关闭标签的下标
    while (i--) {
      if (TabList[i].name === that.activeTab) {
        break
      }
    }
    // 如果标签长度大于2个
    if (TabList.length >= 2) {
      if (i === 0) {
        that.activeTab = TabList[1].name
        localStorage.menuNameActive = TabList[1].name
        localStorage.logMenuName = TabList[1].name
        that.$store.commit('updateActiveTab', TabList[1].name)
        if (that.$route.path.indexOf('Report/ReportsViewList') != -1) {
          that.$router.push({ name: TabList[1].name, query:{t:Date.now()} }, () => {
          })
        } else {
          that.$router.push({ name: TabList[1].name }, () => {
          })
        }
      } else if(that.$router){
        that.activeTab = TabList[i - 1].name
        localStorage.menuNameActive = TabList[i - 1].name
        localStorage.logMenuName = TabList[i - 1].name
        that.$store.commit('updateActiveTab', TabList[i - 1].name)
        if (that.$route.path.indexOf('Report/ReportsViewList') != -1) {
          that.$router.push({ name: TabList[i - 1].name, query:{t:Date.now()} }, () => {
          })
        } else {
          that.$router.push({ name: TabList[i - 1].name }, () => {
          })
        }
      }
    } else {
      that.$router.push('/index')
      localStorage.logMenuName = ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/removeTab.js